<template>
  <div class="home">
    <el-row>
        <el-col :xs="24" :md="12">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>【Geekmath-激活码】下载</span>
                  <el-button style="float: right; padding: 3px 0" type="text" @click="download">确认下载</el-button>
                </div>
                <div class="mt5">
                    <el-select v-model="type" placeholder="请选择激活码类型">
                        <el-option label="推广激活码(限新用户)" :value="1"></el-option>
                        <el-option label="永久激活码(限老用户)" :value="2"></el-option>
                        <el-option label="商业激活码(同账户多次使用)" :value="3"></el-option>
                    </el-select>
                </div>
                <div class="mt5" v-if="type!=2">
                    <el-select v-model="monthValue" placeholder="激活码享受会员时长">
                        <el-option
                          v-for="item in months"
                          :key="item"
                          :label="item + '个月'"
                          :value="item">
                        </el-option>
                      </el-select>
                </div>
                <div class="mt5">
                  <el-date-picker
                    v-model="expireDate"
                    type="datetime"
                    placeholder="激活码使用有效期截止时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    >
                  </el-date-picker>
                </div>
                <div class="mt5">
                    <span>数量:</span><el-input-number v-model="num" :step="100" :max="1000" step-strictly></el-input-number>
                </div>
                <div class="mt5">
                   <el-input placeholder="请输入验证码" v-model="code">
                        <template slot="append"><span @click="getCode">发送验证码</span></template>
                    </el-input>
                </div>
            </el-card>
        </el-col>
    </el-row>
    <el-divider></el-divider>

    <el-row>
        <el-col :xs="24" :md="12">
            <template>
                <el-table
                  :data="memolist"
                  >
                  <el-table-column
                    prop="date"
                    label="日期"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="nickname"
                    label="昵称"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="memo"
                    label="留言">
                  </el-table-column>
                  <el-table-column
                    prop="reply"
                    label="回复">
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入回复内容"
                        v-model="reply" v-if="scope.row.reply === ''||scope.row.reply === null">
                        </el-input>
                        <el-button type="primary" size="small" @click="saveReply(scope.row.id)" v-if="scope.row.reply === ''||scope.row.reply === null">提交</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
        </el-col>
    </el-row>
  </div>
</template>

<script>
import { download } from '@/api/index'
export default {
  name: 'home',
  data() {
      return {
        type:'',
        months:[1,2,3,4,5,6,7,8,9,10,11,12],
        monthValue:'',
        expireDate:'',
        num:'',
        code:'',

        memolist:[],
        reply:'',
        processing:false
      }
   },
   created(){
      this.getList()
   },
   methods:{
      async getCode() { 
            const data = await this.$post('/sms/getAdminCode', {
                type:4
            })
            if(data.result.success){
                this.$message('发送验证码成功');
            }else{
                this.$message(data.result.info)
            }
      },
      async getList(){
           const data = await this.$post('/Activicode/getFeedList', {
            })
            if(!data.result.success){
                this.$message(data.result.info);return;
            }
            this.memolist =  data.result.info
      },
    saveReply(id){
            this.$prompt('请输入口令', '安全提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
            }).then(({ value }) => {
                if(value==undefined || value==""){
                    this.$message('口令不能为空');return ;
                }
                if(this.reply==undefined || this.reply==""){
                    this.$message('回复内容不能为空');return ;
                }
                if(id==undefined || isNaN(id)||id==""){
                    this.$message('回复ID不能为空');return ;
                }
                if(this.processing){
                    this.$message('请等待处理完成');return ;
                }
                this.processing = true;
                this.$post('/Activicode/saveFeedback', {
                  id:id,
                  psw:value,
                  reply:this.reply
                }).then((data)=>{
                    this.processing = false;
                    if(!data.result.success){
                        this.$message(data.result.info);return;
                    }
                    this.$message(data.result.info)
                    this.getList()
                })
            
            }).catch(() => {   
            });
    
      },
      async download(){
         if(this.type==''||(this.type!=1&&this.type!=2&&this.type!=3)){
            this.$message('请选择激活码类型');return false;
         }

         if(this.type==1||this.type==3){
            if(this.monthValue==''){
                this.$message('请选择激活码享受会员时长');return false;
            }
         }

         if(this.expireDate==''){
            this.$message('请选择激活码过期时间');return false;
         }

         if(this.num==''){
            this.$message('请选择激活码类型');return false;
         }

         if(this.type==1||this.type==3){
            if(this.monthValue==''){
                this.$message('请选择激活码享受会员时长');return false;
            }
         }

         if(this.expireDate==''){
            this.$message('请选择激活码的使用有效截止时间');return false;
         }

         if(this.num==''||parseInt(this.num)<=0){
            this.$message('请选择要生成的激活码数量');return false;
         }

         if(this.code==''||isNaN(this.code)){
            this.$message('请输入收到的验证码');return false;
         }

         download("/Activicode/downloadActivicode",{
            type:this.type,
            month:this.monthValue,
            expire:this.expireDate,
            nums:this.num,
            code:this.code
         })
         this.reset()
      },
      reset(){
        this.type=''
        this.monthValue=''
        this.expireDate=''
        this.num=''
        this.code=''
      }
   }
}
</script>
<style scoped>
.text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
  }

  @media screen and (max-width: 450px) {
    .box-card {
        width: 100%;
      }
  }
  .mt5{
    margin-top:1px;
  }
  .mtbig{
    margin-top:30px;
  }
::v-deep .el-input-group{width:50%!important;}
</style>
